import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import App from './components/App';
import Auth from './services/AuthService';
import browserHistory from './history';
import Dashboard from './components/Dashboard';
import Favorites from './components/favorites/Favorites';
import Accounting from './components/Accounting';
import NavPage from './components/NavPage';
import Page from './components/Page';
import BarcodeReceiving from './components/scanner/BarcodeReceiving';
import CycleCounting from './components/scanner/CycleCounting';
import AdditionalMenu from './components/AdditionalMenu';
import TerminalLoader from './components/loader/TerminalLoader';
import UserContainer from './components/user/UserContainer';
import DocsContainer from './components/docs/DocsContainer';
import Chat from './components/chat/Chat';
import ForgotPassword from './components/login/ForgotPassword';
import LoginForm from './components/login/LoginForm';
import Loyalty from './components/loyalty/test';
import AdminDashboard from './components/admin/AdminDashboard';
import DownloadPage from './components/DownloadPage';
import InitialsSetup from './components/InitialsSetup';
import VideoPage from './components/video/VideoPage';

// Conditionally Rendered Components
const TestRouter = process.env.NODE_ENV === 'production' ? Dashboard : require('./components/test/TestRouter').default;

const FormBuilderComponent =
  process.env.NODE_ENV === 'production' && !process.env.REACT_APP_TESTING ? Dashboard : FormBuilder.default; // eslint-disable-line

// This is useful in routes where auth hasn't yet been established.
// eslint-disable-next-line
const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return Auth.loggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} /> // eslint-disable-line
        );
      }}
    />
  );
};

const DocsRender = ({ match }) => <DocsContainer pageName={match.params.pageName} />; // eslint-disable-line

// Top level routes
export default () => (
  <Router history={browserHistory}>
    <App>
      <Switch>
        {/* Static Top Level Routes Outside of Nav Shell */}
        <Route exact path="/login" component={LoginForm} />
        <Route exact path="/forgotpassword" component={ForgotPassword} />
        <Route exact path="/changepassword" component={UserContainer} />
        <AuthRoute path="/terminal/:program" component={TerminalLoader} />

        {/* Otherwise */}
        <Route
          render={props => {
            // Not logged in yet?
            if (!Auth.loggedIn()) {
              // LoginContainer will redirect to requested page after successful login.
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />; // eslint-disable-line
            }

            // eslint-disable-next-line
            if (Auth.mfaRequired() && props.location.pathname !== '/profile/mfa') {
              return <Redirect to={{ pathname: '/profile/mfa', state: { from: props.location } }} />; // eslint-disable-line
            }

            // Otherwise, no need to wrap the following in AuthRoutes since auth has been established
            return (
              <NavPage>
                <Switch>
                  <Route exact path="/admin" component={AdminDashboard} />
                  <Route exact path="/builder/:layout?" component={FormBuilderComponent} />
                  <Route exact path="/home" component={Dashboard} />
                  <Route exact path="/profile/:view?" component={UserContainer} />
                  <Route path="/test" component={TestRouter} />
                  <Route path="/download" component={DownloadPage} />
                  <Route exact path="/chat" component={Chat} />
                  <Route exact path="/favorites" component={Favorites} />
                  <Route exact path="/accounting" component={Accounting} />
                  <Route exact path="/menu/:pageName" component={AdditionalMenu} />
                  <Route exact path="/docs/:pageName" render={DocsRender} />
                  <Route exact path="/db/:pageName" component={Page} />
                  <Route exact path="/db/:pageName/:action(new)" component={Page} />
                  <Route exact path="/db/:pageName/:id" component={Page} />
                  <Route exact path="/db/:pageName/:id/:action/:area?" component={Page} />
                  <Route exact path="/list/:pageName" component={Page} />
                  <Route exact path="/list/:pageName/:action(new)" component={Page} />
                  <Route exact path="/list/:pageName/:id" component={Page} />
                  <Route exact path="/list/:pageName/:id/:action" component={Page} />
                  <Route exact path="/payment/:pageName/:id?/:action?" component={Page} />
                  <Route exact path="/PBM1" component={BarcodeReceiving} />
                  <Route exact path="/PBM2" component={CycleCounting} />
                  <Route exact path="/UST3L" component={InitialsSetup} />
                  <Route exact path="/loyalty" component={Loyalty} />
                  <Route exact path="/video/:id" component={VideoPage} />
                  <Route exact path="/:pageName/:id?/:action?" component={Page} />
                  <Route component={Dashboard} />
                </Switch>
              </NavPage>
            );
          }}
        />
      </Switch>
    </App>
  </Router>
);
